export default {
  recurring: 'recurring-payments',
  payouts: 'payouts',
  businessDocs: 'maf',
  bankAccount: 'finance/bank-account',
  manualPayments: 'manual-payments',
} as const;
